module.exports = __webpack_public_path__ + "img/89.97b3f6fc.jpg";